/**
 * Create by lanyueos@qq.com
 * Axios adapter see: https://github.com/axios/axios/tree/master/lib/adapters
 **/

/**
 * join path
 * toPath('/abc', 'test', '123') // /abc/test/123
 * **/
function toPath () {
  if (arguments.length === 1) return arguments[0] || ''
  const paths = []
  for (let i = (arguments.length - 1); i > -1; i--) {
    if (!arguments[i]) continue
    if (i === 0) paths.unshift(arguments[i].replace(/\/$/, ''))
    else paths.unshift(arguments[i].replace(/(^\/|\/$)/g, ''))
  }

  return paths.join('/')
}

function buildParams (params) {
  const result = []

  for (let key in params) {
    result.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
  }

  return result.join('&')
}

export default function (config) {
  const params = config.params || {}
  let url = toPath(config.url)

  const now = Date.now()
  const callback = params.callback || ('AxiosJsonpCallback' + now)

  params[config.jsonp || 'callback'] =  callback
  params._ = now

  url += (url.indexOf('?') > -1 ? '&' : '?') + buildParams(params)

  return new Promise((resolve, reject) => {
    let script = document.createElement('script')
    const oldFn = window[callback]

    window[callback] = function (res) {
      window[callback] = oldFn
  
      resolve({
        config,
        data: res,
        status: 200,
        headers: {
          'content-type': 'text/javascript'
        },
        statusText: 'OK'
      })
    }

    script.src = url
    script.async = true
  
    script.onload = script.onreadystatechange = function () {

      script.onload = script.onreadystatechange = null
      script.onerror = null

      if (script.parentNode) {
        script.parentNode.removeChild(script)
      }

      script = null
    }

    script.onerror = function (error) {
      reject('Request Error !')
    }

    document.head.appendChild(script)
  })
}
